import FitbitIcon from "@mui/icons-material/Fitbit";
import { Card, CardContent } from "@mui/material";
import { message } from "antd";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import HeaderBread from "../../../components/HeaderBread";
import HomePageCustomizedDragNDrop from "../../../components/UI/HomePageCustomizedDragNDrop";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import Layout from "../../../Layout";
import { addlog } from "../../../utils/ApiCalls/Logs";
import {
  getActivityCategory,
  updatePosition,
} from "../../../utils/ApiCalls/Mobile/ActivityMasters";
import { getVessels } from "../../../utils/ApiCalls/SpecialPage";
import { checkPermission } from "../../../utils/Validation/checkPermission";
import { useCallback } from "react";
import { useRef } from "react";


import SwitchBar from "../../../components/Pages/SwitchBar";
import Logs from "../../../components/Logs";
import { LOG_TYPES } from "../../../utils/Constant/LogConstant";

const HomeMasterInput = () => {
  const [vesselOptions, setVesselOptions] = useState([]);
  const [active, setActive] = useState("listing");
  const [rows, setRows] = useState([]);
  const [rows2, setRows2] = useState([]);
  const [count, setCount] = useState(0);
  const [count2, setCount2] = useState(0);
  const [loadingMore, setLoadingMore] = useState(false);
  const [loadingMore2, setLoadingMore2] = useState(false);

  const params = useParams();
  const [search, setSearch] = useState("");
  const [{ userDetails, permission }, dispatch] = useDataLayerValue();
  const [columns, setColumns] = useState([]);
  const [sort, setSort] = useState();
  const [order, setOrder] = useState("asc");
  const [vesselId, setVesselId] = useState();
  const [activeCat, setActiveCat] = useState();

  const isDraggingRef = useRef(false);
  const observer = useRef();
  const observer2 = useRef();
  const pageRef = useRef(1);
  const pageRef2 = useRef(1);
  const pageSize = 100; // fetch size per load =======================================

  
  // 🔹 NEW: navigation for breadcrumbs (like Shortcuts)
  const navigation = [
    { title: "Home", route: "/" },
    {
      title: "Home Master List",
      route: window?.location?.pathname || "/",
    },
  ];

  // ---------------------- Infinite Scroll Handlers ----------------------
  const lastElementRef = useCallback(
    (node) => {
      if (loadingMore) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && rows.length < count) {
          loadMoreData();
        }
      });
      if (node) observer.current.observe(node);
    },
    [loadingMore, rows, count]
  );

  const lastElementRef2 = useCallback(
    (node) => {
      if (loadingMore2) return;
      if (observer2.current) observer2.current.disconnect();

      observer2.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && rows2.length < count2) {
          loadMoreData2();
        }
      });
      if (node) observer2.current.observe(node);
    },
    [loadingMore2, rows2, count2]
  );

  // ---------------------- API Calls ----------------------

  const loadMoreData = async () => {
    if (!vesselId) return;
    setLoadingMore(true);
    const nextPage = pageRef.current + 1;

    let data = await getActivityCategory({
      page: nextPage,
      limit: pageSize,
      vessel_id: vesselId,
      search,
      sort,
      order,
      parent_check: "active",
      is_active:1,
    });

    if (!data.error && data.data?.length) {
      setRows((prev) => [...prev, ...data.data]);
      pageRef.current = nextPage;
      setCount(data.count);
    }

    setLoadingMore(false);
  };

  const loadMoreData2 = async () => {
    if (!vesselId || !activeCat) return;
    setLoadingMore2(true);
    const nextPage = pageRef2.current + 1;

    let data = await getActivityCategory({
      page: nextPage,
      limit: pageSize,
      vessel_id: vesselId,
      sort,
      order,
      parent_category: activeCat,
      is_active:1,
    });

    if (!data.error && data.data?.length) {
      setRows2((prev) => [...prev, ...data.data]);
      pageRef2.current = nextPage;
      setCount2(data.count);
    }

    setLoadingMore2(false);
  };

  const getData = async () => {
    dispatch({ type: "SET_LOADING", loading: true });
    pageRef.current = 1;
    let data = await getActivityCategory({
      page: 1,
      limit: pageSize,
      vessel_id: vesselId,
      search,
      sort,
      order,
      parent_check: "active",
      is_active:1,
    });
    if (data.error)
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data.error, type: "error" },
      });
    else if (data.data) {
      setRows(data.data);
      setCount(data.count);
    }
    dispatch({ type: "SET_LOADING", loading: false });
  };

  const getData2 = async () => {
    dispatch({ type: "SET_LOADING", loading: true });
    pageRef2.current = 1;
    let data = await getActivityCategory({
      page: 1,
      limit: pageSize,
      vessel_id: vesselId,
      sort,
      order,
      parent_category: activeCat,
      is_active:1,
    });
    if (data.error)
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data.error, type: "error" },
      });
    else if (data.data) {
      setRows2(data.data);
      setCount2(data.count);
    }
    dispatch({ type: "SET_LOADING", loading: false });
  };

  const getOptionLocation = async () => {
    dispatch({ type: "SET_LOADING", loading: true });
    let vessels = await getVessels();
    if (vessels.error) {
      Swal.fire({ icon: "error", title: "Oops...", text: vessels.error });
    } else {
      setVesselOptions(vessels);
    }
    dispatch({ type: "SET_LOADING", loading: false });
  };

  // ---------------------- Position Update ----------------------
  // ---------------------- Position Update ----------------------
 const updateBannerPosition = async (banners, moveInfo) => {
  if (
    !checkPermission(
      permission,
      "update_per",
      "Categories",
      window?.location?.pathname
    )
  )
    return message.error("Update permission missing");

  dispatch({ type: "SET_LOADING", loading: true });

  try {
    const args = {
      search,
      vessel_id: vesselId,
      parent_check: "active",
    };

    const data = await updatePosition(banners, args);

    const movedName = moveInfo?.movedElement?.name;
    const finalPos = moveInfo?.finalPosition;

    const title =
      movedName && finalPos
        ? `${movedName} moved to position ${finalPos}`
        : "Categories position updated";

    addlog(
      "Categories Position Updated",
      LOG_TYPES.HOMEPAGE,
      { title },
      userDetails.id
    );

    if (data.error) {
      Swal.fire({ icon: "error", title: "Oops...", text: data.error });
    }
  } finally {
    dispatch({ type: "SET_LOADING", loading: false });
  }
};



 const updateBannerPosition2 = async (banners, moveInfo) => {
  if (
    !checkPermission(
      permission,
      "update_per",
      "Categories",
      window?.location?.pathname
    )
  )
    return message.error("Update permission missing");

  dispatch({ type: "SET_LOADING", loading: true });

  try {
    const args = {
      search,
      vessel_id: vesselId,
      parent_category: activeCat,
    };

    const data = await updatePosition(banners, args);

    const movedName = moveInfo?.movedElement?.name;
    const finalPos = moveInfo?.finalPosition;

    // 👇 find parent category name based on activeCat
    const parentCategory = rows.find((r) => r.id === activeCat);
    const parentName = parentCategory?.name;

    const title =
      parentName && movedName && finalPos
        ? `${parentName} - ${movedName} moved to position ${finalPos}`
        : "Sub-category position updated";

    addlog(
      "Categories Position Updated",
      LOG_TYPES.HOMEPAGE,
      { title },
      userDetails.id
    );

    if (data.error) {
      Swal.fire({ icon: "error", title: "Oops...", text: data.error });
    }
  } finally {
    dispatch({ type: "SET_LOADING", loading: false });
  }
};


  // ---------------------- Effects ----------------------

  useEffect(() => {
    getOptionLocation();
  }, []);

  useEffect(() => {
    if (vesselOptions.length > 0) {
      const matchedVessel = vesselOptions.find(
        (item) =>
          item.name.toLowerCase().replaceAll(" ", "-") === params?.vessel
      );
      setVesselId(matchedVessel?.id || vesselOptions[0]?.id);
    }
  }, [params, vesselOptions]);

  useEffect(() => {
    if (vesselId) getData();
  }, [vesselId]);

  useEffect(() => {
    if (activeCat) getData2();
  }, [activeCat]);

  // ---------------------- Render ----------------------
  return (
     <>
      <Layout
        type={"read_per"}
        module_data={
          vesselOptions.find(
            (item) =>
              item.name.toLowerCase().replaceAll(" ", "-") === params?.vessel
          )?.name
        }
      >
        {/* 🔹 Same style header as Shortcuts */}
        <CustomHeaderTitle title={"Category Sequence"} />
        <div>
          
          {/* <div>
            <HeaderBread navigation={navigation} title={"Homepage"} />
          </div> */}

          <section className="content" style={{ marginTop: "20px" }}>
            <div className="container-fluid">
              <SwitchBar
                tabs={[
                  { title: "Category Sequence", value: "listing" },
                  { value: "logs", title: "History Logs" },
                ]}
                activeTab={active}
                setActiveTab={setActive}
              />

              {active === "listing" && (
                <div className="card">
                  <div className="card-body">
                    <Card
                      sx={{
                        padding: "10px",
                        border: "1px solid black",
                        mb: "10px",
                      }}
                    >
                      <h4 style={{ fontWeight: "bold" }}>
                        Set Category Order for{" "}
                        {
                          vesselOptions.find(
                            (item) =>
                              item.name
                                .toLowerCase()
                                .replaceAll(" ", "-") === params?.vessel
                          )?.name
                        }
                      </h4>
                      <ul>
                        <li>
                          First 4 categories appear under "Activities to do"
                        </li>
                        <li>
                          Categories 5+ appear under "Do what you love"
                        </li>
                      </ul>
                    </Card>

                    {rows && (
                      <HomePageCustomizedDragNDrop
                          rows={rows}
                          setRows={setRows}
                          updatePosition={updateBannerPosition}
                          disableDrag={!!activeCat}
                          onDragStart={() => {
                            isDraggingRef.current = true;
                          }}
                          onDragEndDone={() => {
                            setTimeout(() => {
                              isDraggingRef.current = false;
                            }, 0);
                          }}
                          render={(page, index) => (
                          <Card key={page.id} variant="outlined">
                             <CardContent
                                sx={{ p: 1, cursor: "pointer" }}
                                onClick={(e) => {
                                  if (isDraggingRef.current) return;
                                  e.stopPropagation();
                                  setActiveCat((prev) => (prev === page.id ? null : page.id));
                                }}
                              >
                              <p style={{ fontWeight: "bold" }}>
                                <FitbitIcon /> #{index + 1} {page?.name}
                              </p>

                              {activeCat === page.id && (
                                <div
                                  style={{
                                    marginTop: "20px",
                                    padding: "20px",
                                  }}
                                >
                                  <HomePageCustomizedDragNDrop
                                     rows={rows2}
                                      setRows={setRows2}
                                      updatePosition={updateBannerPosition2}
                                      onDragStart={() => {
                                        isDraggingRef.current = true;
                                      }}
                                      onDragEndDone={() => {
                                        setTimeout(() => {
                                          isDraggingRef.current = false;
                                        }, 0);
                                      }}
                                      render={(child, idx) => (
                                      <Card
                                        key={child.id}
                                        variant="outlined"
                                        sx={{
                                          mb: 1,
                                          border: "1px solid black",
                                        }}
                                        ref={
                                          idx === rows2.length - 1
                                            ? lastElementRef2
                                            : undefined
                                        }
                                      >
                                        <CardContent sx={{ p: 1 }}>
                                          <p style={{ fontWeight: "bold" }}>
                                            <FitbitIcon /> #{idx + 1}{" "}
                                            {child?.name}
                                          </p>
                                        </CardContent>
                                      </Card>
                                    )}
                                  />
                                </div>
                              )}
                            </CardContent>
                          </Card>
                        )}
                      />
                    )}
                    {loadingMore && <p>Loading more...</p>}
                  </div>
                </div>
              )}

              {active === "logs" && (
                <Logs
                  type={LOG_TYPES.HOMEPAGE}
                  slug={window?.location?.pathname}
                  refreshlog={active}
                />
              )}
            </div>
          </section>
        </div>
      </Layout>
    </>
  );
};

export default HomeMasterInput;